import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';
import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeMegaMenu, setActiveMegaMenu] = useState(null);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const megaMenus = {
    solutions: {
      title: 'Solutions',
      sections: [
        {
          title: 'By Use Case',
          links: [
            { name: 'Digital Transformation', path: '/solutions/digital-transformation' }
          ]
        },
        {
          title: 'By Technology',
          links: [
            { name: 'Web Development', path: '/solutions/web-development' },
            { name: 'Mobile Apps', path: '/solutions/mobile-apps' },
            { name: 'Desktop Apps', path: '/solutions/desktop-apps' }
          ]
        }
      ]
    },
    industries: {
      title: 'Industries',
      sections: [
        {
          title: 'Sectors We Serve',
          links: [
            { name: 'Healthcare', path: '/industries/healthcare' },
            { name: 'Finance', path: '/industries/finance' },
            { name: 'Retail & E-commerce', path: '/industries/retail' },
            { name: 'Manufacturing', path: '/industries/manufacturing' }
          ]
        },
        {
          title: 'More Industries',
          links: [
            { name: 'Education', path: '/industries/education' },
            { name: 'Real Estate', path: '/industries/real-estate' },
            { name: 'Logistics', path: '/industries/logistics' },
            { name: 'Media & Entertainment', path: '/industries/media' }
          ]
        }
      ]
    },
    resources: {
      title: 'Resources',
      sections: [
        {
          title: 'Learn',
          links: [
            { name: 'Case Studies', path: '/resources/case-studies' }
          ]
        },
        {
          title: 'Support',
          links: [
            { name: 'Help Center', path: '/resources/help' },
            { name: 'Community', path: '/resources/community' },
            { name: 'Contact Support', path: '/resources/support' },
            { name: 'FAQ', path: '/resources/faq' }
          ]
        }
      ]
    }
  };

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/" className="logo">SoftLaabs</Link>
          <IconButton 
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
            sx={{ color: '#674A40', display: { sm: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li 
              className="has-megamenu"
              onMouseEnter={() => setActiveMegaMenu('solutions')}
              onMouseLeave={() => setActiveMegaMenu(null)}
            >
              <span className="nav-link-with-dropdown">
                Solutions
                <KeyboardArrowDownIcon sx={{ fontSize: 18, marginLeft: '4px' }} />
              </span>
              {activeMegaMenu === 'solutions' && (
                <div className="mega-menu">
                  <div className="mega-menu-content">
                    {megaMenus.solutions.sections.map((section, idx) => (
                      <div key={idx} className="mega-menu-section">
                        <h3>{section.title}</h3>
                        <ul>
                          {section.links.map((link, linkIdx) => (
                            <li key={linkIdx}>
                              <Link to={link.path}>{link.name}</Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </li>

            <li 
              className="has-megamenu"
              onMouseEnter={() => setActiveMegaMenu('industries')}
              onMouseLeave={() => setActiveMegaMenu(null)}
            >
              <span className="nav-link-with-dropdown">
                Industries
                <KeyboardArrowDownIcon sx={{ fontSize: 18, marginLeft: '4px' }} />
              </span>
              {activeMegaMenu === 'industries' && (
                <div className="mega-menu">
                  <div className="mega-menu-content">
                    {megaMenus.industries.sections.map((section, idx) => (
                      <div key={idx} className="mega-menu-section">
                        <h3>{section.title}</h3>
                        <ul>
                          {section.links.map((link, linkIdx) => (
                            <li key={linkIdx}>
                              <Link to={link.path}>{link.name}</Link>
                            </li>
                          ))}
                        </ul>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </li>
            <li>
              <Link to="/about" className={isActive('/about') ? 'active' : ''}>
                About
              </Link>
            </li>
            <li>
              <Link to="/partners" className={isActive('/partners') ? 'active' : ''}>
                Partners
              </Link>
            </li>
            <li>
              <Link to="/services" className={isActive('/services') ? 'active' : ''}>
                Services
              </Link>
            </li>
            <li>
              <Link to="/contact" className="cta-nav">
                Get a Quote
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
